import { render, staticRenderFns } from "./producers.vue?vue&type=template&id=0ed1194c"
import script from "./producers.vue?vue&type=script&lang=js"
export * from "./producers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports